import { call, put} from "redux-saga/effects";
import {    fetchSubCategoryFields,fetchSubcategory} from "../../firebase/methods";
import { toast } from "react-toastify";
import * as actionsType from "../actions/types";
import axios from "axios";
import Cookies from 'js-cookie'




// export function* listSubCategoryFields({ payload: { id, callback } }) {
//   console.log("Inside subcategory fields saga function", id);
//     try {
//       //yield put(showLoader());
//       let records = yield call(fetchSubCategoryFields, id);
//       //yield put(hideLoader());
//       // console.log("Records : ", records);
//       if (callback) callback();
//       yield put(updateSubCategoryFields(records));
//       // toast.success("Sub category fields fethced successfully.");
//     } catch (error) {
//       //console.log("Error :", error);
//       if (callback) callback();
//       toast.error("An error occurred while fetching sub category fields");
//     }
//   }


const requestGetAllSubCategories = () => {
  return axios.request({
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Cookies.get('token')
    },
      url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-all-sub-categories`
  })
}
  export function* fetchSubCategoryfields() {
      try {
        //yield put(showLoader());
        let data = yield call(requestGetAllSubCategories);
   
       
        yield put({
            type: actionsType.UPDATE_SUBCATEGORIES,
            payload: data.data
        });
        // toast.success("Sub category fields fethced successfully.");
      } catch (error) {
        //console.log("Error :", error);
      
        toast.error("An error occurred while fetching sub category fields");
      }
    }

  